import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatToString } from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'

const Vat = ({ vat = {} }) => {
  const { t } = useTranslation(['billing'])
  const { value = null, currency } = vat

  if (value === null) {
    return null
  }

  return (
    <div className={styles['billing__calculated-data-item']}>
      {t('vat', {
        amount: formatToString(value, currency),
      })}
    </div>
  )
}

Vat.propTypes = {
  vat: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.oneOf(CURRENCIES),
  }),
}
export default Vat
